import React, { useState } from "react";
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import {slides } from '../../data/Data'


function SlideCard() {

  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    setSlide(slide === slides.length - 1 ? 0 : slide + 1);
  };

  const prevSlide = () => {
    setSlide(slide === 0 ? slides.length - 1 : slide - 1);
  };

  return (
    <>
      <div className="content slider">
        <BsArrowLeftCircleFill onClick={prevSlide} className="arrow arrow-left" />

        {slides.map((item, index) => {
          return (
            <div className="boxed" key={item.id || index}>
              <img src={item.src} alt='' key={index}
              className={slide === index ? "slide" : "slide slide-hidden"}/>
            </div>
            
          );
        })}
        
        <BsArrowRightCircleFill onClick={nextSlide} className="arrow arrow-right"/>
        <span className="indicators">
          {slides.map((_, idx) => {
            return (
              <button key={idx} className={
                  slide === idx ? "indicator" : "indicator indicator-inactive tiny-button"
                } onClick={() => setSlide(idx)}>
              </button>
            );
          })}
        </span>
      </div>
    </>
  )
  }

export default SlideCard


